export interface SystemUser {
  id: string;
  username: string;
  realName: string;
  role: string;
  roleKey: string;
  department: string;
  phone: string;
  email: string;
  status: "启用" | "禁用";
  lastLogin: string;
  createTime: string;
  permissions: string[];
}

export interface OperationLog {
  id: string;
  userId: string;
  userName: string;
  realName: string;
  action: string;
  module: string;
  detail: string;
  ip: string;
  device: string;
  result: "成功" | "失败";
  time: string;
}

export interface Role {
  id: string;
  name: string;
  key: string;
  description: string;
  userCount: number;
  permissions: string[];
  createTime: string;
}

export const systemRoles: Role[] = [
  {
    id: "role_001",
    name: "超级管理员",
    key: "super_admin",
    description: "拥有系统所有权限，可管理所有模块和用户",
    userCount: 1,
    permissions: ["*"],
    createTime: "2022-01-01",
  },
  {
    id: "role_002",
    name: "运营管理员",
    key: "ops_admin",
    description: "负责日常运营管理，可查看和操作用户档案、售气、报表",
    userCount: 3,
    permissions: ["profile:view", "profile:edit", "sales:view", "sales:operate", "report:view", "alarm:view", "alarm:handle"],
    createTime: "2022-01-01",
  },
  {
    id: "role_003",
    name: "抄表员",
    key: "meter_reader",
    description: "负责抄表和设备巡检，仅可查看表计数据",
    userCount: 8,
    permissions: ["meter:view", "profile:view", "alarm:view"],
    createTime: "2022-03-15",
  },
  {
    id: "role_004",
    name: "财务人员",
    key: "finance",
    description: "负责财务管理，可查看和操作售气记录、支付、报表",
    userCount: 2,
    permissions: ["sales:view", "payment:view", "payment:operate", "report:view"],
    createTime: "2022-03-15",
  },
  {
    id: "role_005",
    name: "安全员",
    key: "safety_officer",
    description: "负责安全管理，可查看告警和安检记录",
    userCount: 4,
    permissions: ["alarm:view", "alarm:handle", "profile:view", "meter:view"],
    createTime: "2022-06-01",
  },
  {
    id: "role_006",
    name: "只读用户",
    key: "readonly",
    description: "仅可查看系统数据，无任何操作权限",
    userCount: 5,
    permissions: ["profile:view", "meter:view", "report:view"],
    createTime: "2023-01-10",
  },
];

export const systemUsers: SystemUser[] = [
  {
    id: "SU001",
    username: "admin",
    realName: "系统管理员",
    role: "超级管理员",
    roleKey: "super_admin",
    department: "信息技术部",
    phone: "13800000001",
    email: "admin@gascloud.com",
    status: "启用",
    lastLogin: "2026-04-10 09:15:32",
    createTime: "2022-01-01",
    permissions: ["*"],
  },
  {
    id: "SU002",
    username: "zhangwei",
    realName: "张伟",
    role: "运营管理员",
    roleKey: "ops_admin",
    department: "运营管理部",
    phone: "13800000002",
    email: "zhangwei@gascloud.com",
    status: "启用",
    lastLogin: "2026-04-10 08:30:15",
    createTime: "2022-02-15",
    permissions: ["profile:view", "profile:edit", "sales:view", "sales:operate", "report:view", "alarm:view", "alarm:handle"],
  },
  {
    id: "SU003",
    username: "liming",
    realName: "李明",
    role: "运营管理员",
    roleKey: "ops_admin",
    department: "运营管理部",
    phone: "13800000003",
    email: "liming@gascloud.com",
    status: "启用",
    lastLogin: "2026-04-09 17:45:22",
    createTime: "2022-02-15",
    permissions: ["profile:view", "profile:edit", "sales:view", "sales:operate", "report:view", "alarm:view", "alarm:handle"],
  },
  {
    id: "SU004",
    username: "wangfang",
    realName: "王芳",
    role: "财务人员",
    roleKey: "finance",
    department: "财务部",
    phone: "13800000004",
    email: "wangfang@gascloud.com",
    status: "启用",
    lastLogin: "2026-04-10 09:02:11",
    createTime: "2022-03-20",
    permissions: ["sales:view", "payment:view", "payment:operate", "report:view"],
  },
  {
    id: "SU005",
    username: "chengang",
    realName: "陈刚",
    role: "抄表员",
    roleKey: "meter_reader",
    department: "运维部",
    phone: "13800000005",
    email: "chengang@gascloud.com",
    status: "启用",
    lastLogin: "2026-04-10 07:55:40",
    createTime: "2022-04-01",
    permissions: ["meter:view", "profile:view", "alarm:view"],
  },
  {
    id: "SU006",
    username: "liuyang",
    realName: "刘洋",
    role: "抄表员",
    roleKey: "meter_reader",
    department: "运维部",
    phone: "13800000006",
    email: "liuyang@gascloud.com",
    status: "启用",
    lastLogin: "2026-04-09 16:20:08",
    createTime: "2022-04-01",
    permissions: ["meter:view", "profile:view", "alarm:view"],
  },
  {
    id: "SU007",
    username: "zhaohui",
    realName: "赵慧",
    role: "安全员",
    roleKey: "safety_officer",
    department: "安全管理部",
    phone: "13800000007",
    email: "zhaohui@gascloud.com",
    status: "启用",
    lastLogin: "2026-04-10 08:10:55",
    createTime: "2022-06-15",
    permissions: ["alarm:view", "alarm:handle", "profile:view", "meter:view"],
  },
  {
    id: "SU008",
    username: "sunli",
    realName: "孙丽",
    role: "只读用户",
    roleKey: "readonly",
    department: "客服部",
    phone: "13800000008",
    email: "sunli@gascloud.com",
    status: "禁用",
    lastLogin: "2026-03-15 14:30:00",
    createTime: "2023-01-20",
    permissions: ["profile:view", "meter:view", "report:view"],
  },
];

export const operationLogs: OperationLog[] = [
  {
    id: "LOG20260410001",
    userId: "SU001",
    userName: "admin",
    realName: "系统管理员",
    action: "修改系统配置",
    module: "系统设置",
    detail: "修改IoT平台地址为 https://iot.gascloud.com/api/v2",
    ip: "192.168.1.100",
    device: "Chrome 120 / Windows 11",
    result: "成功",
    time: "2026-04-10 09:15:32",
  },
  {
    id: "LOG20260410002",
    userId: "SU002",
    userName: "zhangwei",
    realName: "张伟",
    action: "处理告警",
    module: "告警中心",
    detail: "处理告警 AL20260410003：压力异常，标记为处理中",
    ip: "192.168.1.102",
    device: "Chrome 119 / macOS",
    result: "成功",
    time: "2026-04-10 11:50:00",
  },
  {
    id: "LOG20260410003",
    userId: "SU004",
    userName: "wangfang",
    realName: "王芳",
    action: "导出报表",
    module: "报表分析",
    detail: "导出2026年3月月度报表（PDF格式）",
    ip: "192.168.1.105",
    device: "Edge 120 / Windows 10",
    result: "成功",
    time: "2026-04-10 09:02:11",
  },
  {
    id: "LOG20260410004",
    userId: "SU003",
    userName: "liming",
    realName: "李明",
    action: "购气操作",
    module: "在线售气",
    detail: "为用户 R002 李秀梅 充值购气 200元",
    ip: "192.168.1.103",
    device: "Firefox 121 / Windows 11",
    result: "成功",
    time: "2026-04-10 10:25:44",
  },
  {
    id: "LOG20260410005",
    userId: "SU005",
    userName: "chengang",
    realName: "陈刚",
    action: "查看用户详情",
    module: "档案管理",
    detail: "查看居民用户 R001 张建国 详情页",
    ip: "192.168.1.106",
    device: "Chrome 120 / Android",
    result: "成功",
    time: "2026-04-10 07:55:40",
  },
  {
    id: "LOG20260410006",
    userId: "SU008",
    userName: "sunli",
    realName: "孙丽",
    action: "登录失败",
    module: "用户认证",
    detail: "账号已被禁用，登录失败",
    ip: "192.168.1.110",
    device: "Chrome 118 / Windows 10",
    result: "失败",
    time: "2026-04-10 08:45:12",
  },
  {
    id: "LOG20260409001",
    userId: "SU001",
    userName: "admin",
    realName: "系统管理员",
    action: "新增系统用户",
    module: "用户权限",
    detail: "新增用户 liuyang（刘洋），角色：抄表员",
    ip: "192.168.1.100",
    device: "Chrome 120 / Windows 11",
    result: "成功",
    time: "2026-04-09 14:30:00",
  },
  {
    id: "LOG20260409002",
    userId: "SU002",
    userName: "zhangwei",
    realName: "张伟",
    action: "修改用户档案",
    module: "档案管理",
    detail: "修改工商业用户 C001 老北京涮肉馆 联系电话",
    ip: "192.168.1.102",
    device: "Chrome 119 / macOS",
    result: "成功",
    time: "2026-04-09 16:15:22",
  },
  {
    id: "LOG20260409003",
    userId: "SU007",
    userName: "zhaohui",
    realName: "赵慧",
    action: "下发气价",
    module: "气价管理",
    detail: "批量下发阶梯气价方案至12台设备",
    ip: "192.168.1.108",
    device: "Chrome 120 / Windows 11",
    result: "成功",
    time: "2026-04-09 10:05:33",
  },
  {
    id: "LOG20260409004",
    userId: "SU003",
    userName: "liming",
    realName: "李明",
    action: "生成AI报告",
    module: "报表分析",
    detail: "生成2026年Q1季度AI综合分析报告",
    ip: "192.168.1.103",
    device: "Firefox 121 / Windows 11",
    result: "成功",
    time: "2026-04-09 09:30:15",
  },
  {
    id: "LOG20260408001",
    userId: "SU001",
    userName: "admin",
    realName: "系统管理员",
    action: "修改角色权限",
    module: "用户权限",
    detail: "修改角色「安全员」权限，新增 alarm:handle 权限",
    ip: "192.168.1.100",
    device: "Chrome 120 / Windows 11",
    result: "成功",
    time: "2026-04-08 15:20:00",
  },
  {
    id: "LOG20260408002",
    userId: "SU004",
    userName: "wangfang",
    realName: "王芳",
    action: "查看支付记录",
    module: "支付充值",
    detail: "查询2026年3月全部支付记录，共156条",
    ip: "192.168.1.105",
    device: "Edge 120 / Windows 10",
    result: "成功",
    time: "2026-04-08 11:45:30",
  },
];

export const iotConfig = {
  platform: {
    name: "华为云IoT平台",
    apiUrl: "https://iot.gascloud.com/api/v2",
    wsUrl: "wss://iot.gascloud.com/ws",
    appId: "gascloud_prod_001",
    appSecret: "••••••••••••••••",
    region: "cn-north-4",
    status: "已连接",
    lastSync: "2026-04-10 14:20:00",
    deviceCount: 1256,
    onlineCount: 1198,
  },
  protocols: [
    { name: "MQTT", port: 8883, enabled: true, tls: true },
    { name: "HTTP", port: 443, enabled: true, tls: true },
    { name: "CoAP", port: 5684, enabled: false, tls: false },
    { name: "LwM2M", port: 5685, enabled: false, tls: false },
  ],
  dataSync: {
    interval: 30,
    retryCount: 5,
    retryInterval: 60,
    batchSize: 100,
    timeout: 10,
  },
  security: {
    tlsVersion: "TLS 1.3",
    certExpiry: "2027-01-01",
    authMode: "证书+密钥双重认证",
    ipWhitelist: ["192.168.1.0/24", "10.0.0.0/8"],
  },
};
